import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;

  text-align: start;

  ${theme.breakpoints.up("desktop")} {
    margin-block-start: 0;
  }
`;

export const GoogleNewsButton = styled.button`
  display: flex;
  gap: 6px;
  align-items: center;

  padding-block: 6px;
  padding-inline: 8px;

  color: #ffffff;
  font-weight: 500;
  font-size: 16px;

  border: none;
  border-radius: 4px;

  background: #f7f7f7;

  cursor: pointer;
`;

export const GoogleNewsIcon = styled.span`
  flex-shrink: 0;

  inline-size: 24px;
  block-size: 24px;
`;

export const TextContent = styled.span`
  color: #333333;
  font-size: 12px;
  font-family: Roboto;
  line-height: normal;
  white-space: nowrap;
`;

export const ImageGoogle = styled.img`
  display: block;

  inline-size: 16px;
  block-size: 16px;
`;
